import React, { useState } from 'react';
import classNames from 'classnames';
import classes from '../../styles/Checkbox.module.scss';
import Checkmark from '../../icons/Checkmark';
import { CheckedBox, UncheckedBox } from '../../icons/CheckboxIcons';
import Text from './Text';

type CheckboxProps = {
  // whether or not it's checked
  checked: boolean;
  // id to inject into the component
  id?: string;
  // className to inject into the component
  className?: string;
  // style prop to inject into the component
  style?: any;
  // background color when not checked
  defaultBackgroundColor?: string;
  // background color when checked
  checkedBackgroundColor?: string;
  // checkmark color when checked
  checkmarkColor?: string;
  // event listeners
  onClick: (e: React.MouseEvent<HTMLInputElement>) => any;
};

export default function Checkbox({
  checked,
  id,
  className,
  style,
  defaultBackgroundColor = '#fff',
  checkedBackgroundColor = '#1890FF',
  checkmarkColor = '#fff',
  onClick,
}: CheckboxProps) {
  return (
    <div
      tabIndex={0}
      onKeyDown={(e: any) => {
        if (e.keyCode === 32) {
          onClick(e);
        }
      }}
      id={id}
      className={classNames(classes.checkbox, className)}
      onClick={onClick}
      style={{
        backgroundColor: checked
          ? checkedBackgroundColor
          : defaultBackgroundColor,
        ...style,
      }}
    >
      {checked && (
        <Checkmark width={11} height={11} fillColor={checkmarkColor} />
      )}
    </div>
  );
}

type Checkbox2Props = {
  // whether or not the box is checked
  checked: boolean;
  // cb to fire when the box is clicked on
  onClick: (e: React.MouseEvent<HTMLInputElement>) => any;
  // if disabled, box will be grayed out. onClick handler is still controlled by the parent component though
  disabled?: boolean;
  // text that will show up next to the checkbox if provided
  label?: string;
  // id to apply to the top level div of this component
  id?: string;
  // class(es) to apply to the top level div of this component
  className?: string;
  // inline styles to apply to the top level div of this component
  style?: any;
};

export function Checkbox2({
  checked,
  onClick,
  disabled,
  label,
  id,
  className,
  style,
}: Checkbox2Props) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      id={id}
      style={style}
      className={classNames(classes.checkbox2Container)}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onKeyDown={(e: any) => {
        if (e.keyCode === 32) {
          onClick(e);
        }
      }}
      tabIndex={0}
    >
      <div
        className={classNames(
          classes.checkbox2Circle,
          {
            [classes.isHovered]: isHovered && !disabled,
          },
          className
        )}
      >
        <div className={classes.checkbox2}>
          {checked ? (
            <CheckedBox fillColor={disabled ? '#bec0cb' : '#0369E0'} />
          ) : (
              <UncheckedBox
                fillColor={isHovered && !disabled ? '#0369E0' : '#bec0cb'}
              />
            )}
        </div>
      </div>
      {label && (
        <Text
          type="Body2"
          className={classNames(classes.checkbox2Label, {
            [classes.checkbox2LabelDisabled]: disabled,
          })}
        >
          {label}
        </Text>
      )}
    </div>
  );
}
